// extracted by mini-css-extract-plugin
export default {"container":"placeholder_container__8of2v","icon":"placeholder_icon__S2WXs"};